import { type ApiRequisition } from '@Model';
import { requisitionActionOf } from '@utils/requisitionAction';

/** What the home page calls the customer's next requisition, by what it is about. */
// @ai-generated 2026-09-25T13:32:16+00:00 by matthias.gessinger@synqony.com using Claude Opus 5.5 (1M context)
export function nextRequisitionTitle(requisition: Pick<ApiRequisition, 'container_actions'>): string {
    switch (requisitionActionOf(requisition)) {
        case 'placement':
            return 'Ihre nächste Aufstellung';
        case 'pickup':
            return 'Ihre nächste Abholung';
        case 'emptying':
            return 'Ihre nächste Leerung';
        case 'swap':
            return 'Ihr nächster Tausch';
        case 'material':
            return 'Ihr nächster Termin';
    }
}
